import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=7d62e21f&scoped=true&"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=7d62e21f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d62e21f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
